import { useEffect, useMemo, useState } from 'react'
import debounce from 'lodash.debounce'

export const useDebouncedSearchInput = (onUpdate: (value: string) => void, timeout = 500) => {
  const [value, setValue] = useState('')
  const debouncedOnUpdate = useMemo(() => debounce(onUpdate, timeout), [onUpdate, timeout])
  useEffect(() => {
    debouncedOnUpdate(value)
  }, [debouncedOnUpdate, value])
  useEffect(() => () => debouncedOnUpdate.cancel(), [debouncedOnUpdate])

  return useMemo(
    () => ({ value, setValue, flush: debouncedOnUpdate.flush }),
    [debouncedOnUpdate.flush, value]
  )
}
